import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { StopWord } from '../models/stop-word.model';
import { RestUtils } from './rest-utils';
import { Observable } from 'rxjs';

@Injectable()
export class StopWordsService {
  http: HttpClient;

  utils = new RestUtils();

  headers = new HttpHeaders();

  constructor(http: HttpClient) {
    this.http = http;
    this.headers = this.headers.set('Content-Type', 'application/json');
  }

  contents(service: 'lnt' | 'mnt' | 'mo'): Observable<string[]> {
    const url = this.utils.buildUrl(`ROLE/stop-words/${service}/contents`);
    const options = this.utils.getHttpHeaderOptions(this.headers);

    return this.http.get<string[]>(url, options);
  }

  all() {
    const url = this.utils.buildUrl('ROLE/stop-words');
    const options = this.utils.getHttpHeaderOptions(this.headers);

    return this.http.get<StopWord[]>(url, options);
  }

  save(stopWord: StopWord) {
    const options = this.utils.getHttpHeaderOptions(this.headers);
    if (stopWord.id) {
      const url = this.utils.buildUrl(`ROLE/stop-words/${stopWord.id}`);
      return this.http.put<StopWord>(url, stopWord, options);
    }
    const url = this.utils.buildUrl(`ROLE/stop-words`);
    return this.http.post<StopWord>(url, stopWord, options);
  }

  updateFlags(stopWord: StopWord) {
    const url = this.utils.buildUrl(`ROLE/stop-words/${stopWord.id}/flags`, {
      lnt: stopWord.lnt ? 'true' : 'false',
      mnt: stopWord.mnt ? 'true' : 'false',
      mo: stopWord.mo ? 'true' : 'false',
    });
    const options = this.utils.getHttpHeaderOptions(this.headers);
    return this.http.patch<StopWord>(url, {}, options);
  }

  delete(stopWord: StopWord) {
    const url = this.utils.buildUrl(`ROLE/stop-words/${stopWord.id}`);
    const options = this.utils.getHttpHeaderOptions(this.headers);
    return this.http.delete<StopWord>(url, options);
  }

  create(): StopWord {
    return {
      id: null,
      content: '',
      category: 'General',
      mnt: true,
      lnt: true,
      mo: true,
    };
  }
}
